<script setup lang="ts">
import type { SmsChatMessageFullUnitProps } from '@/components/units/SmsChatMessageFullUnit.vue';

import { useTemplateRef, watch } from 'vue';

import SimpleLoader from '@/components/loaders/SimpleLoader.vue';
import TableEmptyText from '@/components/texts/TableEmptyText.vue';
import SmsChatMessageFullUnit from '@/components/units/SmsChatMessageFullUnit.vue';

export interface Props {
  messages?: SmsChatMessageFullUnitProps[];
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  messages: () => [],
  loading: false,
});

const rootEl = useTemplateRef('root');

watch(
  [() => props.messages, () => props.loading],
  async function () {
    if (!props.messages.length) return;
    if (props.loading) return;
    // HACK find a better way to catch the right moment to scroll down the messages
    setTimeout(() => {
      rootEl.value?.scrollTo({
        top: rootEl.value.scrollHeight,
        behavior: 'smooth',
      });
    }, 100);
    rootEl.value?.scrollTo({
      top: rootEl.value.scrollHeight,
      behavior: 'smooth',
    });
  },
  { immediate: true },
);
</script>

<template>
  <div
    ref="root"
    :class="$style.smsChatMessagesSection"
    data-testid="smsChatMessagesSection"
  >
    <div v-if="props.loading">
      <SimpleLoader :size="64" :width="6" class="m-auto my-8" />
    </div>
    <TableEmptyText v-else-if="!props.messages.length">
      No conversation selected
    </TableEmptyText>
    <template v-else>
      <SmsChatMessageFullUnit
        v-for="message in props.messages"
        :key="message.id"
        :class="$style.message"
        :name="message.name"
        :datetime="message.datetime"
        :message="message.message"
        :icon="message.icon"
        :is-own="message.isOwn"
      />
    </template>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatMessagesSection {
}
  .message {
  }
</style>
